import { render, staticRenderFns } from "./base_delivery.vue?vue&type=template&id=30aa5818&scoped=true&"
import script from "./base_delivery.vue?vue&type=script&lang=js&"
export * from "./base_delivery.vue?vue&type=script&lang=js&"
import style0 from "./base_delivery.vue?vue&type=style&index=0&id=30aa5818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa5818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30aa5818')) {
      api.createRecord('30aa5818', component.options)
    } else {
      api.reload('30aa5818', component.options)
    }
    module.hot.accept("./base_delivery.vue?vue&type=template&id=30aa5818&scoped=true&", function () {
      api.rerender('30aa5818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/deliveries/base/base_delivery.vue"
export default component.exports